module.exports = __webpack_public_path__ + "img/setup-single-package-min.c0dc86b8.jpg";